import { _ as e, a as t } from "../../../_rollupPluginBabelHelpers-d2f9cf82.js";
import r, { useContext as a } from "react";
import i from "../../../contexts/state-context.js";
import { s as l } from "../../../style-inject.es-1f59c1d0.js";
import n from "../BasicButton/BasicButton.js";
import s from "../../IconsMapper/IconsMapper.js";
import { S as p, a as c } from "../../../swiper.min-fcb62bfb.js";
import o from "../../../services/Images.js";
import m from "../../../services/Url.js";
import "../Spinner/Spinner.js";
import "@fortawesome/react-fontawesome";
import "@fortawesome/free-solid-svg-icons";
l(".richFieldNewsfeedWrapper {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between; }\n\n.richFieldNewsfeedNewsWrapper {\n  width: 31%;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: var(--gutter-l);\n  text-overflow: ellipsis; }\n\n.richFieldNewsfeedNewsWrapper h4 {\n  margin-bottom: var(--gutter-m);\n  font-size: 14px;\n  width: 100%;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden; }\n\n.richFieldNewsfeedNewsWrapper p {\n  display: -webkit-box;\n  -webkit-line-clamp: 4;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  height: 65px; }\n\n.richFieldNewsfeedNewsPictureWrapper {\n  overflow: hidden;\n  height: 100px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: var(--gutter-m); }\n\n.richFieldNewsfeedNewsPictureWrapper img {\n  width: 100%;\n  object-fit: contain; }\n\n.richFieldNewsfeedNewsCTA {\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n  margin-top: 5px; }\n\n.richFieldNewsfeedNewsWrapper a:link,\n.richFieldNewsfeedNewsWrapper a:active,\n.richFieldNewsfeedNewsWrapper a:visited {\n  color: black; }\n");
var d = function (l) {
    var n = l.section,
      d = l.style,
      g = void 0 === d ? {} : d,
      w = l.classes,
      u = void 0 === w ? {} : w,
      W = a(i),
      h = e(W, 1)[0].brand.logo_uri,
      b = {
        headerTitle: g.headerTitle || {},
        title: g.title || {},
        desc: g.desc || {},
        img: g.img || {},
        imgWrapper: g.imgWrapper || {},
        fullContainer: g.fullContainer || {},
        fullWrapper: g.fullWrapper || {},
        newsWrapper: g.newsWrapper || {},
        newsTextWrapper: g.newsTextWrapper || {},
        paragraph: g.paragraph || {},
        buttonWrapper: g.buttonWrapper || {},
        button: g.button || {},
        carouselView: g.carouselView || !1,
        srcSet: g.srcSet || "small",
        titleWrapper: g.titleWrapper || {}
      },
      N = {
        headerTitle: u.headerTitle || "",
        title: u.title || "",
        desc: u.desc || "",
        img: u.img || "",
        imgWrapper: u.imgWrapper || "",
        fullContainer: u.fullContainer || "",
        fullWrapper: u.fullWrapper || "",
        newsWrapper: u.newsWrapper || "",
        newsTextWrapper: u.newsTextWrapper || "",
        paragraph: u.paragraph || "",
        buttonWrapper: u.buttonWrapper || "",
        button: u.button || "",
        titleWrapper: u.titleWrapper || ""
      };
    return n = o.srcSetRichFields(b.srcSet, n), r.createElement("div", {
      className: "componentWrapper componentWrapperFlex " + N.fullContainer,
      style: b.fullContainer
    }, n.title && r.createElement("h2", {
      style: b.headerTitle,
      className: N.headerTitle
    }, n.icon && r.createElement(s, {
      icon: n.icon
    }), n.title), r.createElement("div", {
      className: "richFieldNewsfeedWrapper " + N.fullWrapper,
      style: b.fullWrapper
    }, b.carouselView ? r.createElement(p, {
      spaceBetween: 20,
      slidesPerView: 1.1
    }, n.fields.map(function (e, a) {
      e.cta_target = m.modifyHTTP(e.cta_target);
      var i = t(t({}, b.button), {}, {
          label: e.cta_label,
          href: e.cta_target
        }),
        l = e.id || e._id || e.slug || a;
      return r.createElement(c, {
        key: l
      }, r.createElement(f, {
        field: e,
        styleConfig: b,
        classesConfig: N,
        buttonConfig: i,
        fallBackPicture: h,
        index: l
      }));
    })) : r.createElement(r.Fragment, null, n.fields.map(function (e, a) {
      e.cta_target = m.modifyHTTP(e.cta_target);
      var i = t(t({}, b.button), {}, {
          label: e.cta_label,
          href: e.cta_target
        }),
        l = e.id || e._id || e.slug || a;
      return r.createElement(f, {
        key: l,
        field: e,
        styleConfig: b,
        classesConfig: N,
        buttonConfig: i,
        fallBackPicture: h,
        index: l
      });
    }))));
  },
  f = function (e) {
    var t = e.field,
      a = e.styleConfig,
      i = e.classesConfig,
      l = e.buttonConfig,
      p = e.fallBackPicture,
      c = e.index;
    return t.cta_target = m.modifyHTTP(t.cta_target), t.image = m.modifyHTTP(t.image), r.createElement("div", {
      className: "richFieldNewsfeedNewsWrapper " + i.newsWrapper,
      key: c,
      style: a.newsWrapper
    }, r.createElement("div", {
      className: "richFieldNewsfeedNewsPictureWrapper " + i.imgWrapper,
      style: a.imgWrapper
    }, t.cta_target ? r.createElement("a", {
      href: t.cta_target,
      target: "_blank",
      rel: "nofollow noopener noreferrer",
      style: {
        width: "100%"
      }
    }, r.createElement("img", {
      loading: "lazy",
      style: a.img,
      className: i.img,
      src: "" !== t.image ? t.image : p,
      alt: t.title
    })) : r.createElement("img", {
      loading: "lazy",
      style: a.img,
      className: i.img,
      src: "" !== t.image ? t.image : p,
      alt: t.title
    })), r.createElement("div", {
      className: "richFieldNewsfeedTextWrapper " + i.newsTextWrapper,
      style: a.newsTextWrapper
    }, r.createElement("h3", {
      style: a.titleWrapper,
      className: i.titleWrapper
    }, t.icon && r.createElement(s, {
      icon: t.icon
    }), t.cta_target ? r.createElement("a", {
      href: t.cta_target,
      target: "_blank",
      style: a.title,
      className: i.title,
      rel: "nofollow noopener noreferrer"
    }, t.title) : r.createElement("div", {
      style: a.title,
      className: i.title
    }, t.title)), r.createElement("p", {
      style: a.paragraph,
      className: i.paragraph
    }, t.cta_target ? r.createElement("a", {
      href: t.cta_target,
      target: "_blank",
      style: a.desc,
      className: i.desc,
      rel: "nofollow noopener noreferrer"
    }, t.desc) : r.createElement("div", {
      style: a.desc,
      className: i.desc
    }, t.desc)), r.createElement("div", {
      className: "richFieldNewsfeedNewsCTA " + i.buttonWrapper,
      style: a.buttonWrapper
    }, t.cta_target && r.createElement(n, l))));
  };
export { d as default };